module.exports = __webpack_public_path__ + "static/media/logo_shb.ab091289.svg";